import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePersistedLocation } from 'app/modules/tailor/hooks/usePersistedLocation';

import useFetchHelpCenter from './fetch/useFetchHelpCenter';
import useInitialLocation from './useInitialLocation';
import { useRouteDetermination } from './useRouteDetermination';

export default function useModuleRedirect() {
  const { tailorUrl } = useInitialLocation();
  const { data: helpCenter } = useFetchHelpCenter();
  const [persistedLocation] = usePersistedLocation();
  const [redirected, setRedirected] = useState(false);
  const navigate = useNavigate();

  const redirectTarget = useRouteDetermination({
    allowNull: true,
    checkRedirectConstraints: true,
    persistedLocation,
    tailorUrl,
  });

  const prevStatusChangeDate = useRef<string>('');
  const currentStatusChangeDate = helpCenter?.valid_until_date_str || '';

  useEffect(() => {
    if (!helpCenter || redirected || !redirectTarget) return;

    navigate(redirectTarget, { state: { skipAnimation: true } });
    setRedirected(true);
  }, [navigate, helpCenter, redirected, redirectTarget]);

  useEffect(() => {
    if (!prevStatusChangeDate.current) {
      prevStatusChangeDate.current = currentStatusChangeDate;
      return;
    }

    if (currentStatusChangeDate !== prevStatusChangeDate.current) {
      prevStatusChangeDate.current = currentStatusChangeDate;
      setRedirected(false);
    }
  }, [currentStatusChangeDate]);
}
